import React, { useContext, useEffect, useRef, useState } from 'react';
import SimpleBar from 'simplebar-react';

//content
import SimpleTable from '../global/tables/SimpleTable/SimpleTable';
import ItemInMultiplePlacesNotification from './ItemInMultiplePlacesNotification';

//hooks
import useContentAudience from './ContentAudience.hook';

//interfaces
import { ITableContent } from  '@/interfaces/simpleTable';

//context
import { ContentAudienceContext } from './ContentAudienceContext';

//helpers
import { simpleBarAutoScrollHandler } from  '@/helpers/SimpleBar';


interface IEditAudience {
    title:string,
    EditAudienceUpperControls?: JSX.Element,
    SearchAndFilter?:JSX.Element,
    table: ITableContent, 
    EditAudienceBottomControls?: JSX.Element,
    currentTableSelection: string,
}


const EditAudience = ({title, EditAudienceUpperControls, EditAudienceBottomControls, SearchAndFilter, table, currentTableSelection }: IEditAudience) => {
    const simpleBarRef = useRef();
    const {filterIsOpen, totalRecords, showExistsInMultiplePlaces, usersOrGroupsLoading, currentSelectionChanged, filterOptions} = useContext(ContentAudienceContext);

    const [tableHeight, setTableHeight] = useState<number>(88)

    const {getNoDataMessage, getNextPage, isArchivedFilterOn} = useContentAudience();


    function getTableHeight(): number {
        if(!table.rows.length) {
            return  88
        }

        return table.rows.length >= 9 ? 400 : table.rows.length * 40 + 35
    }

    function getModalHeight() {
        return tableHeight + 200 + (filterIsOpen ? 120 : 0) + (showExistsInMultiplePlaces ? 55 : 0)
    }

    function setHeight(){
        const modal: HTMLDivElement = (document.querySelector('.EditAudience') || document.querySelector('.AddAudience')) as HTMLDivElement;
        if(modal) {
            modal.style.height = `${getModalHeight()}px`;
        }
    }

    useEffect(() => {
        setHeight();
    },[filterIsOpen, showExistsInMultiplePlaces, tableHeight])

    useEffect(() => {
        if(currentSelectionChanged) {
            return;
        }
        if(!usersOrGroupsLoading ) {
            if(table?.rows?.length) {
                setTableHeight(getTableHeight())
            }
            else {
                setTableHeight(88);
            }
        }
    },[usersOrGroupsLoading, table?.rows?.length, currentSelectionChanged])

    return (
        <section>
            <h2 className='edit-audience-header'>{title}</h2>

            {showExistsInMultiplePlaces && <ItemInMultiplePlacesNotification />}
        
            {!!EditAudienceUpperControls && <div className={'edit-audience-upper-controls-wrapper'}>{EditAudienceUpperControls}</div>}

            {!!SearchAndFilter && SearchAndFilter}

            <div className={`edit-audience-table-wrapper ${currentTableSelection} ${isArchivedFilterOn ? 'has-status-column' : ''}`}>
                <SimpleBar
                    className='edit-audience-simple-bar'
                    style={{ maxHeight: 390 , margin: '12px 0 5px', border: '1px solid #e3e3e3', borderRadius:'4px', height: tableHeight, transition: '0.4s height'}}
                    scrollableNodeProps={{ 
                        ref: simpleBarRef,
                        onScroll: (e: React.UIEvent<HTMLElement>) => simpleBarAutoScrollHandler(e, totalRecords > table.rows.length && !usersOrGroupsLoading, getNextPage)
                    }}
                >
                    <SimpleTable
                        simpleTableContent={table} 
                        isInfiniteScroll={true} 
                        noDataMessage={getNoDataMessage()} 
                        key={currentTableSelection}
                        isLoading={false}
                        infiniteScrollFetchCondition={!!table?.rows?.length && usersOrGroupsLoading}
                    />
                    
                </SimpleBar>
            </div>
        
            {!!EditAudienceBottomControls && <div className= 'edit-audience-bottom-controls-wrapper'>{EditAudienceBottomControls}</div>}
        </section>
    )
}

export default EditAudience;